<template>
  <div class="why-baroun-section" role="region" aria-labelledby="why-baroun-heading">
    <div id="why-baroun-heading" class="title" aria-hidden="false">لماذا منصة البارون التعليمية؟</div>

    <div class="list" role="list">
      <div class="d-flex align-items-start my-3" role="listitem">
        <div>
          <strong class="feature-title">محتوى تعليمي متميز</strong>
          <p>شرح <span class="highlight">مفصل لكل المناهج الدراسية</span> بأسلوب سهل ومبسط لسهولة الفهم.</p>
        </div>
      </div>

      <div class="d-flex align-items-start my-5" role="listitem">
        <div>
          <strong class="feature-title">مدرسون أكفاء</strong>
          <p>نخبة من <span class="highlight">أفضل المعلمين المتخصصين</span> في مناهج الثانوية المصرية والسعودية.</p>
        </div>
      </div>

      <div class="d-flex align-items-start my-5" role="listitem">
        <div>
          <strong class="feature-title">متابعة مستمرة</strong>
          <p><span class="highlight">تقييم الأداء ومتابعة مستمرة</span> لتحسين المستوى الدراسي مع اختبارات دورية.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'whybaron'
}
</script>

<style scoped>
.why-baroun-section {
  background-image: url('../../assets/images/whybaron-bg.png');
  background-size: cover;
  background-position: left top;
  padding: 50px 100px;
  color: white;
  margin-top: 30px;
  position: relative;
}

.title {
  color: black;
  top: 30px;
  position: absolute;
  font-size: 36px;
  font-weight: bold;
}

.list {
  margin-top: 80px;
  padding-top: 20px;
  margin-bottom: 30px;
}

.feature-title {
  font-size: 1.6rem;
  font-weight: bold;
  display: block;
  margin-bottom: 5px;
}

.list p {
  font-size: 1.1rem;
  line-height: 1.6;
}

.highlight {
  color: #FFD700;
  font-weight: bold;
}

/* Responsive Design */
@media screen and (max-width: 1100px) {
  .why-baroun-section {
    padding: 20px;
    background-position: center bottom;
  }

  .title {
    font-size: 30px;
    top: 40px;
  }

  .list {
    padding-top: 140px;
    padding-bottom: 90px;
  }
}

@media screen and (max-width: 600px) {
  .why-baroun-section {
    padding: 15px;
    background-position: center bottom;
  }

  .title {
    font-size: 28px;
    top: 30px;
  }

  .list {
    padding-top: 130px;
    padding-bottom: 80px;
  }
}

@media screen and (max-width: 400px) {
  .title {
    font-size: 24px;
  }

  .feature-title {
    font-size: 1.35rem;
  }
}
</style>